import { render } from "./profile_setting.vue?vue&type=template&id=9bcf6da4"
import script from "./profile_setting.vue?vue&type=script&lang=js"
export * from "./profile_setting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__